// src/components/Footer.jsx
import styles from './Footer.module.css';

export default function Footer() {
  return (
    <footer className={styles.footer}>
      <div className={styles.left}>De Vivo y Asociados ®</div>
      <div className={styles.right}>Powered by Estudio-Pixel</div>
    </footer>
  );
}
